import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getProfileData(uid, callback) {
	console.log('getProfileData is running');
	await firebaseRef.ref('/users/' + uid).on('value', async (snapshot) => {
		var userObj;

		var fullName = snapshot.val()?.fullName;
		var email = snapshot.val()?.email;
		var phoneNumber = snapshot.val()?.phoneNumber;
		var photoUrl = snapshot.val()?.photoURL;
		var userType = snapshot.val()?.projectRoles?.[PROJECT_CODE.projectCode];
		let projectRole =
			snapshot.val()?.projectRoles?.[PROJECT_CODE.projectCode];
		let roleName = '';
		if (projectRole) {
			await firebaseRef
				.ref(
					'/kavtek_roles/' +
						PROJECT_CODE.projectCode +
						'/' +
						projectRole
				)
				.once('value', (snapshot) => {
					roleName = snapshot.val()?.roleName ?? '';
				});
		}

		function getCompanyInfo(company) {
			firebaseRef
				.ref('/kavtek_companies/' + PROJECT_CODE.projectCode)
				.on('value', (snapshot) => {
					var name = snapshot?.val()?.companyName;
					var picture = snapshot?.val()?.companyPictureUrl;

					var companyInfo = {
						name: name,
						picture: picture,
					};

					company(companyInfo);
				});
		}
		getCompanyInfo((company) => {
			if (
				photoUrl === undefined ||
				photoUrl === null ||
				photoUrl === ''
			) {
				var storageRef = firebase
					.storage()
					.ref(
						PROJECT_CODE.projectCode +
							'/users/default/defaultUser.png'
					);

				var companyStorageRef = firebase
					.storage()
					.ref(
						PROJECT_CODE.projectCode +
							'/companyInfo/companyImage/default/placeholder-company.png'
					);

				if (company.picture) {
					storageRef.getDownloadURL().then((url) => {
						photoUrl = url;
						userObj = {
							fullName: fullName,
							email: email,
							phoneNumber: phoneNumber,
							userType: userType,
							roleName: roleName,
							profilePicture: url,
							companyName: company.name,
							companyPicture: company.picture,
						};

						callback(userObj);
					});
				} else {
					companyStorageRef.getDownloadURL().then((companyUrl) => {
						storageRef.getDownloadURL().then((url) => {
							photoUrl = url;
							userObj = {
								fullName: fullName,
								email: email,
								phoneNumber: phoneNumber,
								userType: userType,
								roleName: roleName,
								profilePicture: url,
								companyName: company.name,
								companyPicture: companyUrl,
							};

							callback(userObj);
						});
					});
				}

				console.log('This is in the if ', userObj);
			} else {
				var companyStorageRef = firebase
					.storage()
					.ref(
						PROJECT_CODE.projectCode +
							'/companyInfo/companyImage/default/placeholder-company.png'
					);

				var storageRef = firebase
					.storage()
					.ref(
						PROJECT_CODE.projectCode +
							'/users/default/defaultUser.png'
					);

				if (company.picture) {
					userObj = {
						fullName: fullName,
						email: email,
						phoneNumber: phoneNumber,
						userType: userType,
						roleName: roleName,
						profilePicture: photoUrl,
						companyName: company.name,
						companyPicture: company.picture,
					};

					callback(userObj);
				} else {
					companyStorageRef.getDownloadURL().then((companyUrl) => {
						console.log('companyUrl', companyUrl);
						userObj = {
							fullName: fullName,
							email: email,
							phoneNumber: phoneNumber,
							userType: userType,
							roleName: roleName,
							profilePicture: photoUrl,
							companyName: company.name,
							companyPicture: companyUrl,
						};

						callback(userObj);
					});
				}
			}
		});
	});
}
